import { jsx as a } from "react/jsx-runtime";
import { Box as N, Button as p, IconButton as x } from "@chakra-ui/react";
import { createContext as B } from "@chakra-ui/react-utils";
import { forwardRef as r, omitThemingProps as h, useMultiStyleConfig as b, StylesProvider as v, chakra as y, useStyles as l } from "@chakra-ui/system";
import { cx as m, __DEV__ as d } from "@chakra-ui/utils";
import * as _ from "react";
import { UtilStyledIcon as C } from "../../utils/utilStyledIcon.mjs";
import { useSection as w } from "./use-section.mjs";
const [I, f] = B({
  strict: !0,
  name: "SectionContext",
  errorMessage: "useSectionContext: `context` is undefined. Seems you forgot to wrap section components in `<Section />`"
}), g = r(
  ({ children: s, ...t }, n) => {
    const c = h(t), e = b("Section", t), o = w(t), i = {
      ...o
    };
    return /* @__PURE__ */ a(I, { value: i, children: /* @__PURE__ */ a(v, { value: e, children: /* @__PURE__ */ a(
      y.section,
      {
        ref: n,
        ...o.getSectionProps(c),
        className: m("odi-section", t.className),
        __css: e.section,
        children: s
      }
    ) }) });
  }
);
d && (g.displayName = "Section");
const M = r(
  (s, t) => {
    const { className: n, ...c } = s, e = m("odi-section__header", n), i = {
      ...l().header
    };
    return /* @__PURE__ */ a(
      y.header,
      {
        ref: t,
        className: e,
        ...c,
        __css: i
      }
    );
  }
);
d && (M.displayName = "SectionHeader");
const R = r(
  (s, t) => {
    const { className: n, ...c } = s, e = m("odi-section__title-row", n), i = {
      ...l().titleRow
    };
    return /* @__PURE__ */ a(
      y.div,
      {
        ref: t,
        className: e,
        ...c,
        __css: i
      }
    );
  }
);
d && (R.displayName = "SectionTitleRow");
const T = r(
  (s, t) => {
    const { className: n, ...c } = s, { titleId: e, setTitleMounted: o } = f();
    _.useEffect(() => (o(!0), () => o(!1)), [o]);
    const i = m("odi-section__title", n), S = {
      flex: 0,
      ...l().title
    };
    return /* @__PURE__ */ a(
      y.h2,
      {
        ref: t,
        className: i,
        id: e,
        ...c,
        __css: S
      }
    );
  }
);
d && (T.displayName = "SectionTitle");
const J = (s) => {
  const t = l();
  return /* @__PURE__ */ a(
    C,
    {
      customClassname: "chakra-section__icon",
      styleConfig: t.icon,
      ...s
    }
  );
}, E = r(
  (s, t) => {
    const { className: n, ...c } = s, { descriptionId: e, setDescriptionMounted: o } = f();
    _.useEffect(() => (o(!0), () => o(!1)), [o]);
    const i = m("odi-section__description", n), u = l();
    return /* @__PURE__ */ a(
      y.div,
      {
        ref: t,
        className: i,
        id: e,
        ...c,
        __css: u.description
      }
    );
  }
);
d && (E.displayName = "SectionDescription");
const P = r(
  (s, t) => {
    const { className: n, ...c } = s, e = m("odi-section__body", n), { setBodyMounted: o } = f();
    _.useEffect(() => (o(!0), () => o(!1)), [o]);
    const u = {
      ...l().body
    };
    return /* @__PURE__ */ a(
      y.div,
      {
        ref: t,
        ...c,
        __css: u,
        className: e
      }
    );
  }
);
d && (P.displayName = "SectionBody");
const D = r(
  (s, t) => {
    const { className: n, ...c } = s, e = m("odi-section__footer", n), i = {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      ...l().footer
    }, { setFooterMounted: u } = f();
    return _.useEffect(() => (u(!0), () => u(!1)), [u]), /* @__PURE__ */ a(
      y.footer,
      {
        ref: t,
        ...c,
        __css: i,
        className: e
      }
    );
  }
);
d && (D.displayName = "SectionFooter");
const F = r((s, t) => {
  const { className: n, ...c } = s, e = m("odi-section__box", n), i = {
    ...l().box
  };
  return /* @__PURE__ */ a(N, { ref: t, ...c, sx: i, className: e });
});
d && (F.displayName = "SectionBox");
const j = r((s, t) => {
  const { className: n, ...c } = s, e = m("odi-section__button", n), i = {
    ...l().button
  };
  return /* @__PURE__ */ a(
    p,
    {
      ref: t,
      variant: "outline",
      ...c,
      sx: i,
      className: e
    }
  );
});
d && (j.displayName = "SectionButton");
const k = r(
  (s, t) => {
    const { className: n, ...c } = s, e = m("odi-section__icon-button", n), i = {
      ...l().iconButton
    };
    return /* @__PURE__ */ a(
      x,
      {
        ref: t,
        variant: "daemon",
        ...c,
        sx: i,
        className: e
      }
    );
  }
);
d && (k.displayName = "SectionIconButton");
export {
  g as Section,
  P as SectionBody,
  F as SectionBox,
  j as SectionButton,
  E as SectionDescription,
  D as SectionFooter,
  M as SectionHeader,
  J as SectionIcon,
  k as SectionIconButton,
  T as SectionTitle,
  R as SectionTitleRow
};
